import { changeArrayItemIndex } from 'utils/arrayUtils';

export const dateRangeDurationInWeeks = 7;

export const changeOtherChartItemIndex = <T>(chartData: T[], key: keyof T) => {
  const otherChartItemIndex = chartData.findIndex((chartItem) => {
    const value = chartItem[key];

    return typeof value === 'string' && value.toLowerCase() === 'other';
  });

  if (otherChartItemIndex === -1) {
    return chartData;
  }

  return changeArrayItemIndex<T>(
    chartData,
    otherChartItemIndex,
    chartData.length,
  );
};
